import { createSelector } from 'reselect';
import columns from '../../../../../react-table/helpers/columns';
import { carrierNumberedMailboxColumns } from '../../../common/CarditResditByPostMetadataMapper';
import ReportsDefinition from '../../../../../common/config/ReportDefinitions';

export const getData = ReportsDefinition.RESDIT_BY_RECEIVING_POST_NUMBERED.getDataFunction();

const getMetadata = state => state.reporting.RESDIT_BY_RECEIVING_POST_NUMBERED.metadata;

export const getGeneratedOnDateTime = state =>
  getMetadata(state) && getMetadata(state).generatedOnDateTime;

export const getIsLoading = state => state.reporting.RESDIT_BY_RECEIVING_POST_NUMBERED.isLoading;

export const getUserType = state => state.userData.userType;

export const getColumns = createSelector(getMetadata, getData, (metadata, data) => {
  if (!metadata || !metadata.columns) {
    return [];
  }
  const { TextColumn } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Post', 'mailbox'),
        new TextColumn('Mailbox', 'firstColumnName'),
        new TextColumn('Version', 'version'),
      ],
    }, ...carrierNumberedMailboxColumns(metadata.columns.slice(3), data),
  ];
});
